import { Alert, Select, Table } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ListPagination, ListResponseLogBean, LogBean } from 'src/api/api'
import logApi from './LogApi'
import './style.css'

const Column = Table.Column
const { Option } = Select

interface LogListProps {
}

const LogList = (props: LogListProps) => {

    const navigateTo = useNavigate()
    const { entity, id } = useParams<{ entity: string, id: string }>()

    const [error, setError] = useState()
    const [data, setData] = useState<LogBean[]>([])
    
    const [pagination, setPagination] = useState<any>({
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1
    })

    useEffect(() => loadData(pagination.current), [])

    const loadData = (page) => {

        logApi.list(entity, id, pagination.defaultPageSize, page)
            .then((pageLogBean: ListResponseLogBean) => {
                const logBeans = pageLogBean.data?.map(item => item.data) as LogBean[]

                const newPagination: ListPagination = pageLogBean.pagination as ListPagination

                setData(logBeans)
                setPagination({
                    ...pagination,
                    total: newPagination.total,
                    current: newPagination.currentPage
                })
            })
            .catch(e => setError(e.error))
    }

    const handleChangeEntityType = (key) => {
        if (key) {
            navigateTo('/logs/' + key)
        } else {
            navigateTo('/logs/')
        }
    }

    const jsonRender = json => {
        return (
            <ul className="change-log-text-area">{Object.keys(json).map(k => {
                const value = json[k]
                return <li className="change-log-table-value-content" key={k}>{k}: {value && typeof value == 'object' ? jsonRender(value) : valueRender(value)}</li>
            })}</ul>
        )
    }

    const valueRender = value => <span className="fw500">{typeof value == 'boolean' ? value ? 'true' : 'false' : value}</span>

    const prettify = value => {
        const json = JSON.parse(value || '{}')
        return jsonRender(json)
    }

    return (
        <div>
            {error && <div><Alert message={error} type="error" /><br /></div>}
            {/* <div className="list-header-group">
                <div style={{ marginRight: 8 }}>
                    <Select placeholder="Entity type" onChange={handleChangeEntityType} style={{ width: 160 }} allowClear >
                        <Option value={EntityEnum.Advertiser} key={EntityEnum.Advertiser}>Advertisers</Option>
                        <Option value={EntityEnum.InsertionOrder} key={EntityEnum.InsertionOrder}>Insertion Orders</Option>
                        <Option value={EntityEnum.Campaign} key={EntityEnum.Campaign}>Campaigns</Option>
                        <Option value={EntityEnum.Creative} key={EntityEnum.Creative}>Creatives</Option>
                        <Option value={EntityEnum.Dsp} key={EntityEnum.Dsp}>DSP</Option>
                        <Option value={EntityEnum.DspEndPoint} key={EntityEnum.DspEndPoint}>DSP Endpoint</Option>
                        <Option value={EntityEnum.Conversion} key={EntityEnum.Conversion}>Conversion</Option>
                    </Select>
                </div>
                <div className="c-l-search-buttons">
                    <Input
                        placeholder="Logs search"
                        value={searchText}
                        disabled={id == undefined}
                        onChange={e => {
                            setSearchText(e.target.value as any)
                            setSearchedColumn('name')
                        }}
                    />
                    <Button onClick={handleReset} disabled={id == undefined} style={{ marginRight: 8 }}>
                        <CloseOutlined />
                    </Button>
                </div>
                <Button >Download</Button>
            </div> */}
            <Table<LogBean>
                scroll={{ x: 'max-content' }}
                className="change-log-table"
                rowKey="id"
                size="middle"
                pagination={{
                    ...pagination,
                    onChange: page => loadData(page)
                }}
                dataSource={data}
            >
                <Column className="change-log-table-cell" key="type" title="Entity Type" dataIndex="type" />
                <Column className="change-log-table-cell" key="entityId" title="Entity ID" dataIndex="entityId" />
                <Column className="change-log-table-cell" key="account" title="Account ID" dataIndex="account" />
                <Column
                    className="change-log-table-value"
                    key="prevValue"
                    title="Prev Value"
                    render={(text: string, record: LogBean) => prettify(record.prevValue)}
                />
                <Column
                    className="change-log-table-value"
                    key="currentValue"
                    title="Current Value"
                    render={(text: string, record: LogBean) => prettify(record.currentValue)}
                />
                <Column className="change-log-table-cell" key="dateTime" title="Date/Time" dataIndex="date" />
            </Table>
        </div>
    )
}

export default LogList


// WEBPACK FOOTER //
// ./src/component/app/log/LogList.tsx